// A 401 on most endpoints means this app's own session JWT expired or is
// invalid — main.tsx's global fetch patch clears it and hard-redirects to
// /login. /api/auth/entra/session is the one exception: its Authorization
// header carries a one-time Microsoft access token, not this app's session
// JWT — there is no session to expire yet, since this call is what MINTS
// the session. A 401 there means the Entra→portal exchange itself failed
// (tenant not permitted, no CU mapped, JWKS lookup failed), and
// AuthCallback.tsx's own `if (!res.ok)` branch already surfaces that reason
// verbatim. The global handler firing first hard-navigated to /login before
// that branch ever ran — the real cause of the exchange failure was always
// getting silently thrown away, which is why every previous MSAL-focused
// fix (redirect-race memoization, navigateToLoginRequestUrl) never actually
// resolved the "bounces to /login with no error" report: those fixes were
// correct, but the failure was happening one step later than any of them
// looked.
export function shouldRedirectOn401(url: string, hadAuth: boolean): boolean {
  return hadAuth && !url.endsWith('/api/auth/entra/session');
}
